export default __webpack_public_path__ + "static/media/no-flag-placeholder.fcd9d5e6.svg";